import axios from "axios";
import { API_BASE } from "../../config/env";
export const FETCH_APPLICATIONDETAIL_FULFILLED = "FETCH_APPLICATIONDETAIL_FULFILLED";
export const FETCH_APPLICATIONDETAIL_REJECTED = "FETCH_APPLICATIONDETAIL_REJECTED";
export const FETCH_APPLICATIONDETAIL_PENDING = "FETCH_APPLICATIONDETAIL_PENDING";
export const RESET_APPLICATIONDETAIL = "RESET_APPLICATIONDETAIL"

export function applicationDetail(applicationId) {
    const token = localStorage.getItem("accessToken")

    return (dispatch) => {
        dispatch({
            type: "FETCH_APPLICATIONDETAIL",
            payload: axios({
                method: "get",
                url: `${API_BASE}/api/v3/second-opinion/application-detail?applicationId=${applicationId}`,
                headers: {
                    "Authorization": "Bearer " + token,
                    "Accept-Language": "tr-tr",
                    "Client-Id": localStorage.getItem("One-Id"),
                    "One-Id": localStorage.getItem("Client-Id"),
                    "Content-Type": "application/json",
                    "ngrok-skip-browser-warning": "69920"
                },
            }).then((result) => result.data),
        });
    };
}

export function resetApplicationDetail() {
    return (dispatch) => {
        dispatch({
            type: "RESET_APPLICATIONDETAIL",
        });
    };
}




